import { ImpactItem } from "./ImpactItem";
import { gapAppUrl, getGapProjectImpactUrl } from "../../api/gap";
import { Flex, Link, Text } from "@chakra-ui/react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ImpactList = _ref => {
  let {
    impacts,
    displayKarmaAttribution = true
  } = _ref;
  return /*#__PURE__*/_jsxs(Flex, {
    gap: 2,
    flexDir: "column",
    py: 6,
    px: 3,
    children: [/*#__PURE__*/_jsx("h4", {
      className: "text-3xl",
      children: "Project impacts"
    }), impacts.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Text, {
        className: "text-[18px]",
        children: ["Total impacts (", impacts.length, ")"]
      }), impacts.map(impact => /*#__PURE__*/_jsx(ImpactItem, {
        impact: impact,
        url: getGapProjectImpactUrl(impact.refUID)
      }, impact.uid)), displayKarmaAttribution && /*#__PURE__*/_jsxs(Text, {
        fontFamily: "DM Mono",
        textAlign: "center",
        className: "text-xs",
        children: ["Data provided by Karma via", " ", /*#__PURE__*/_jsx(Link, {
          href: gapAppUrl,
          target: "_blank",
          children: /*#__PURE__*/_jsx(Text, {
            as: "span",
            className: "text-gitcoin-violet-500",
            children: "gap.karmahq.xyz"
          })
        }), "."]
      })]
    }) : /*#__PURE__*/_jsxs(Text, {
      children: ["No previous impacts are being tracked for this project. If you're the owner of this project, visit", " ", /*#__PURE__*/_jsx(Link, {
        target: "_blank",
        href: gapAppUrl,
        children: /*#__PURE__*/_jsx(Text, {
          as: "span",
          className: "text-gitcoin-violet-500",
          children: "gap.karmahq.xyz"
        })
      }), " ", "to add your project and post updates."]
    })]
  });
};